"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERROR_MESSAGES_STREAM = exports.ERROR_MESSAGES_WEBSOCKETS = exports.ERROR_MESSAGES_POLLING = exports.DEFAULT_MAX_ATTEMPTS = exports.DEFAULT_INTERVAL = void 0;
exports.DEFAULT_INTERVAL = 1000;
exports.DEFAULT_MAX_ATTEMPTS = 999999;
const ERROR_MESSAGES_BASE = {
    CONNECTION_ALREADY_CLOSED: 'There is not a open connection to close',
    CONNECTION_ALREADY_OPEN: 'Connection already is open',
    MAX_ATTEMPTS_EXCEEDED: 'Maximum number of attempts exceeded',
};
exports.ERROR_MESSAGES_POLLING = Object.assign(Object.assign({}, ERROR_MESSAGES_BASE), { CONNECTION_NOT_OPEN: 'There is not a open connection or configured sendDataFn to send data' });
exports.ERROR_MESSAGES_WEBSOCKETS = Object.assign(Object.assign({}, ERROR_MESSAGES_BASE), { CONNECTION_NOT_OPEN: 'There is not a open connection' });
exports.ERROR_MESSAGES_STREAM = Object.assign(Object.assign({}, ERROR_MESSAGES_BASE), { CONNECTION_STREAM_ERROR: 'Error on stream connection' });
//# sourceMappingURL=index.js.map